import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../config/editor-environment';
import { SKIP_ERROR_INTERCEPTOR, TwoFactorVerificationResponse } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TwoFactorAuthService {
  private http = inject(HttpClient);

  /**
   * Verify 2FA token
   */
  verifyToken(preAuthToken: string, token: string): Observable<TwoFactorVerificationResponse> {
    return this.http.post<TwoFactorVerificationResponse>(
      `${environment.API_ADDRESS}/auth/verify-2fa`,
      { preAuthToken, token },
      { context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true) }
    ).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  /**
   * Verify backup code
   */
  verifyBackupCode(preAuthToken: string, code: string): Observable<TwoFactorVerificationResponse> {
    return this.http.post<TwoFactorVerificationResponse>(
      `${environment.API_ADDRESS}/auth/verify-backup-code`,
      { preAuthToken, code },
      { context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true) }
    ).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  /**
   * Validate 2FA token format (6 digits)
   */
  validateTokenFormat(token: string): boolean {
    if (token && token.length === 6) {
      return /^\d{6}$/.test(token);
    }
    return false;
  }

  /**
   * Validate backup code format (8 characters)
   */
  validateBackupCodeFormat(code: string): boolean {
    return /^[A-Z0-9]{8}$/.test(code.toUpperCase());
  }
}
